export const domains = {
  url: '/api',
  auth: `https://${process.env.REACT_APP_DEBUG ? 'dev-' : ''}auth.ayomi.fr`,
  website: `https://${process.env.REACT_APP_DEBUG ? 'dev.ayomi.fr' : 'ayomi.fr'}`,
};

export const EU_COUNTRY_WITH_VAT = [
  'DE', 'AT', 'BE', 'BG', 'CY', 'HR', 'DK', 'ES', 'EE', 'FI', 'FR', 'EL',
  'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'CZ', 'RO',
  'SK', 'SI', 'SE',
];
